package com.example.mystybag.remoteLogger

import io.ktor.client.request.forms.submitForm
import io.ktor.http.parameters
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.launch
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@OptIn(ExperimentalTime::class)
internal class RemoteLoggerImpl {

    var walletID    : Long?     = null
    var resourceID  : String    = "-"
    var logLevel    : Int       = RemoteLogger.TYPE_CUSTOM

    private val logUrl          = "logs/logger.php"
    private val scope           = CoroutineScope(Dispatchers.Default)
    private val client          = LoggerRestConnection.getLogHttpClient()
    private val channel         = Channel<String>(capacity = 100)
    private val separator       = "-".repeat(64)

    init {
        scope.launch {
            /*for (message in channel) {
                try {
                    client.submitForm(
                        url            = logUrl,
                        formParameters = parameters {
                            append("walletID", walletID?.toString() ?: "")
                            append("messageData", message)
                        }
                    )
                }
                catch (_: Exception) {}
            }*/
        }
    }

    fun log(ex: Exception) {
        val message = ex.message.toString().plus("\n").plus(ex.stackTraceToString())
        log(message, RemoteLogger.TYPE_EXCEPTION)
    }

    fun log(message: String, level: Int) {
        if ((logLevel and level) > 0) {
            val timestamp = Clock.System.now().toEpochMilliseconds()
            scope.launch {
                try {
                    val time       = parseDate(timestamp)
                    val logMessage = "#MSG $time $resourceID \n$message \n$separator"
                    channel.send(logMessage)
                }
                catch (_: Exception) {}
            }
        }
    }
}

